import { AlertDialog, AlertDialogAction, AlertDialogCancel, AlertDialogContent, AlertDialogDescription, AlertDialogFooter, AlertDialogHeader, AlertDialogTitle } from "@/components/ui/alert-dialog"
import { Loader2 } from "lucide-react"
import { UserDomain } from "@/types/domains"
import { useDeleteDomain } from "@/hooks/useAddDomain"

function RemoveDialog({ 
  showRemove, 
  setShowRemove, 
  userDomain, 
}: {
  showRemove: boolean, 
  setShowRemove: (open: boolean) => void, 
  userDomain: UserDomain, 
}) {
  const { mutate: deleteDomain, isPending: deleteLoading } = useDeleteDomain(); 
  return (
    <AlertDialog open={showRemove} onOpenChange={setShowRemove}>
    <AlertDialogContent>
      <AlertDialogHeader>
        <AlertDialogTitle>Remove Domain</AlertDialogTitle>
      </AlertDialogHeader>
      <AlertDialogDescription>
        Are you sure you want to remove <span className="font-bold text-red-500 underline">{userDomain?.domain}</span> domain?
      </AlertDialogDescription>
      <AlertDialogFooter>
        <AlertDialogCancel>Cancel</AlertDialogCancel>
          <AlertDialogAction 
           className="bg-red-600 hover:bg-red-700 text-white"
           onClick={(e) => {
             e.preventDefault();
             deleteDomain(userDomain.domain, { 
               onSuccess: () => { 
                 setShowRemove(false) 
               } 
             });
           }}
           disabled={deleteLoading}
           >
            {deleteLoading 
              ? <><Loader2 className="mr-2 size-5 animate-spin" />Removing... </>
              : <>Remove</>
            }
          </AlertDialogAction>
      </AlertDialogFooter>
    </AlertDialogContent>
  </AlertDialog>
  )
}

export default RemoveDialog